import emoji from "react-easy-emoji";
/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, 
};

//Home Page
const greeting = {
  title:  "Hi all, I'm Parth",
  logo_name: "PPM",
  nickname: "p_square_m",
  subTitle: emoji(
    "I'm a Full Stack Developer 🚀 from Gujarat, India. Currently I am working in Infosys 🏢. Love Coding 👨‍💻 & Enjoy Learning 📕."),
  resumeLink:
    "https://drive.google.com/file/d/1A33QsDexIIfv6XIwYA85AzXq11nzohXX/view?usp=sharing",
  portfolio_repository: "https://github.com/ppm143",
};

const socialMediaLinks = [
  
  {
    name: "Github",
    link: "https://github.com/ppm143/",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/parthmpatel143/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:parthpatel.daiict@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/ppm__143/",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  
  {
    name: "Instagram",
    link: "https://www.instagram.com/p_square_m/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: emoji("Full Stack Development 💻"),
      fileName: "FullStackImg",
      skills: [
        emoji("⚡ Building resposive website front end using React, Angular, Bootstrap."),
        emoji("⚡ Developing mobile applications using Flutter, React Native "),
        emoji("⚡ Creating application backend in Node, Java"),
        emoji("⚡ Crazy full stack developer who want to explore every tech stack"),
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Angular",
          fontAwesomeClassname: "simple-icons:angular",
          style: {
            color: "#DD0031",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#007396",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
      ],
    },
    {
      title: emoji("Competitive Coding 👨‍💻"),
      fileName: "CodingImg",
      skills: [
        emoji("⚡ Highly passionate to solve challenging problems"),
        emoji("⚡ Good command on Data structures and Algorithms"),
        emoji("⚡ Highly active on competitive coding platform"),
      ],
      softwareSkills: [
        {
          skillName: "LeetCode",
          fontAwesomeClassname: "simple-icons:leetcode",
          style: {
            color: "#2F2F2F",
          },
        },
        {
          skillName: "Hackerrank",
          fontAwesomeClassname: "simple-icons:hackerrank",
          style: {
            color: "#1BA94C",
          },
        },
        {
          skillName: "CodeChef",
          fontAwesomeClassname: "simple-icons:codechef",
          style: {
            color: "#6D3B1C ",
          },
        },
        {
          skillName: "CodeForces",
          fontAwesomeClassname: "simple-icons:codeforces",
          style: {
            color: "#1F88CA",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/WakeUp_Montu",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/p_square_m",
    },
    
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@parthpatel5",
    },
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#000000",
      },
      profileLink: "https://leetcode.com/p_square_m/",
    },
    {
      siteName: "CodeForces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1E91D0",
      },
      profileLink: "https://codeforces.com/profile/prthptl14",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Dhirubhai Ambani Institute of Information and Communication Technology",
      subtitle: "B.Tech. (Honours) in ICT with minor in Computational Science",
      logo_path: "daiict.png",
      alt_name: "DA-IICT",
      duration: "2016 - 2020",
      descriptions: [
        `⚡ I have studied basic software engineering subjects like Data Structures,
        Design and Analysis Algorithms,
        Operating Systems,
        Database Management System,
        High-Performance Computing(HPC) etc.`,
      ],
      website_link: "https://www.daiict.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Data Structures & Algorithms, Level-up Course(2021)",
      subtitle: "- Coding Minutes",
      logo_path: "DSA.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-704493d9-6613-4cd5-a680-84baa547bbab/",
      alt_name: "Data Structures & Algorithms, Level-up Course(2021)",
      color_code: "#00000099",
    }, 
    {
      title: "Problem Solving (Intermediate) Certificate",
      subtitle: "- HackerRank",
      logo_path: "hackerrank_logo.png",
      certificate_link:
        "https://www.hackerrank.com/certificates/30d1b6ed692d",
      alt_name: "Problem Solving (Intermediate) Certificate",
      color_code: "#4285F499",
    },
    {
      title: "Google Analytics for Beginners",
      subtitle: "- Google Analytics",
      logo_path: "google_analytics_logo.png",
      certificate_link:
        "https://analytics.google.com/analytics/academy/certificate/OL1yhSE9QwyJMhM76xo6UQ",
      alt_name: "Google Analytics for Beginners",
      color_code: "#D83B0199",
    },
    // {
    //   title: "Data Science",
    //   subtitle: "- Alex Aklson",
    //   logo_path: "ibm_logo.png",
    //   certificate_link:
    //     "https://www.coursera.org/account/accomplishments/verify/DTGAXLXP9WCC",
    //   alt_name: "IBM",
    //   color_code: "#1F70C199",
    // },

    // {
    //   title: "SQL for Data Science",
    //   subtitle: "- University of California, Davis",
    //   logo_path: "UC_Davis_logo.png",
    //   certificate_link:
    //     "https://coursera.org/share/aceb208e4869b4cddb2b4b05e9bd1d5e",
    //   alt_name: "UC Davis",
    //   color_code: "#1F70C199",
    // },
    // {
    //   title: "Data Visualization",
    //   subtitle: "- John Hart",
    //   logo_path: "coursera_logo.png",
    //   certificate_link:
    //     "https://coursera.org/share/14adc28b47253bdcf02f77800194fd61",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },    
    // {
    //   title: "Front-End Web UI Frameworks and Tools: Bootstrap 4",
    //   subtitle: "- The Hong Kong University of Science and Technology",
    //   logo_path: "HKU.jpg",
    //   certificate_link:
    //     "https://coursera.org/share/6aca47adece3f7840564929e9528cd70",
    //   alt_name: "deeplearning.ai",
    //   color_code: "#00000099",
    // },
    // {
    //   title: "Linux for Developers",
    //   subtitle: "- The Linux Foundation",
    //   logo_path: "Tlf_logo.png",
    //   certificate_link:
    //     "https://coursera.org/share/b1d12afb0f897fb2706a5ae3389c02fb",
    //   alt_name: "The Linux Foundation",
    //   color_code: "#0C9D5899",
    // },

    //    {
    //   title: "Programming for Web with JavaScript",
    //   subtitle: "- Chris Murphy",
    //   logo_path: "penn_logo.png",
    //   certificate_link:
    //     "https://courses.edx.org/certificates/a87191b5c0124260bfa135c3a1cf0bf2",
    //   alt_name: "edX",
    //   color_code: "#FFBB0099",
    // },

  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work and Internship",
  description:
    "I have completed Internships & Full Time Job in the field of Full Stack Development that gave me industry exposure on both Front End and Back End development.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Full Stack Developer",
          company: "Infosys",
          company_url: "https://www.infosys.com/",
          logo_path: "infosys_logo.png",
          duration: "October 2020 - PRESENT",
          location: "Pune, Maharashtra",
          description:
            `Developed a standalone Azure cloud-based Web Application that provided business information about various Power BI and Tableau dashboards to client
            Worked on the front end development using angular inline with business requirements
            Contributed on project migration and fixed issues
            Built wrapper service in java using spring boot framework for integration with different modules in microservice based project.`,
          color: "#0879bf",
        }
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Software Developer Intern",
          company: "Cloudera",
          company_url: "https://www.cloudera.com/",
          logo_path: "cloudera_logo.png",
          duration: "January 2020 - June 2020",
          location: "Bengaluru, Karnataka",
          description:
            `Developed a User Audit System that means maintaining a record of login by the user. It monitors user login access. 
            User Audit System is a part of a Data Analytics Studio web app.
            Data Analytics Studio is a tool for debugging and reporting tools on Hive.
            Technology Stack - Java, Restful API (Jersey), JDBC/Jdbi, PostgreSQL database`,
          color: "#ee3c26",
        },
      ],
    },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     {
    //       title: "Google Explore ML Facilitator",
    //       company: "Google",
    //       company_url: "https://about.google/",
    //       logo_path: "google_logo.png",
    //       duration: "June 2019 - April 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
    //       color: "#4285F4",
    //     },
    //     {
    //       title: "Microsoft Student Partner",
    //       company: "Microsoft",
    //       company_url: "https://www.microsoft.com/",
    //       logo_path: "microsoft_logo.png",
    //       duration: "Aug 2019 - May 2020",
    //       location: "Hyderabad, Telangana",
    //       description:
    //         "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
    //       color: "#D83B01",
    //     },
    //     {
    //       title: "Mozilla Campus Captain",
    //       company: "Mozilla",
    //       company_url: "https://www.mozilla.org/",
    //       logo_path: "mozilla_logo.png",
    //       duration: "Oct 2019 - May 2020",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
    //       color: "#000000",
    //     },
    //     {
    //       title: "Developer Students Club Member",
    //       company: "DSC BIET",
    //       company_url:
    //         "",
    //       logo_path: "dsc_logo.png",
    //       duration: "Jan 2020 - Present",
    //       location: "Kurnool, Andhra Pradesh",
    //       description:
    //         "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
    //       color: "#0C9D58",
    //     },
    //     {
    //       title: "Developer Program Member",
    //       company: "Github",
    //       company_url: "https://github.com/",
    //       logo_path: "github_logo.png",
    //       duration: "July 2019 - PRESENT",
    //       location: "Work From Home",
    //       description:
    //         "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating peoper documentation for project.",
    //       color: "#181717",
    //     },
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Web Design and Development projects and deploy them to web applications using Heroku, netlify.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "parth.jpg",
    description:
      "I am available on almost every social media. You can message me, I will try to reply within 24 hours. I can help you with DSA, OOPS, C/C++, JavaScript, React, Angular, Node, MERN/MEAN Full Stack Web Development.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://freeprogrammings.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "05/ShivSagar Banglows, Near Bus-stop, Ranasan, Gujarat-382870.",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/6HDnrx2hv1uaELXu8",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 9512333406",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
